const {PureComponent} = require("react");
const PropTypes = require("prop-types");
const router = require("app/services/router");
const Image = require("app/components/mixins/Image");
const Link = require("app/components/mixins/Link");
const debounce = require("app/util/debounce");
const screen = require("app/util/screen");

class GroupItem extends PureComponent {

	static get propTypes() {
		return {
			title: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired
		}
	}

	get className() {
		let classList = [];

		if (this.props.url === router.currentUrl) {
			classList.push("active");
		}

		return classList.join(" ");
	}

	render() {
		return (
			<li className={this.className}>
				<a href={this.props.url}>{this.props.title}</a>
			</li>
		);
	}

}

class Group extends PureComponent {
	constructor(props) {
		super(props);
		this.innerGroupRef = React.createRef();

		this.state = {
			open: false
		};
	}

	_toggleCollapse = e => {
		if (screen.mobile()) {
			e.preventDefault()
			this.setState({open: !this.state.open})
		}
	}

	get innerGroupHeight () {
		return this.innerGroupRef.current.offsetHeight
	}

	static get propTypes() {
		return {
			title: PropTypes.string.isRequired,
			url: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			url: "#"
		};
	}

	get linkClassName() {
		let classList = ["title"];

		if (this.props.url === "#") {
			classList.push("no-link");
		}

		return classList.join(" ");
	}

	render() {

		const {url} = this.props;

		return (
			<li className={this.state.open ? 'open' : ''}>
				<Link href={url} className={this.linkClassName} preventDefault={url === '#'}>{this.props.title}</Link>
				{this.props.children.length > 0 ? <div className="inner-expand-toggle" onClick={this._toggleCollapse}><Image src={router.url("img/arrow_down.png")} alt={this.props.title}/></div> : null}
				<div className={['groups-inner', this.state.open ? 'open' : ''].join(' ')} style={{ maxHeight: this.state.open ? this.innerGroupHeight : null }}>
					<ul ref={this.innerGroupRef}>{this.props.children}</ul>
				</div>
			</li>
		);
	}
}

class MenuItem extends PureComponent {

	static get propTypes() {
		return {
			title: PropTypes.string.isRequired,
			url: PropTypes.string,
			items: PropTypes.array,
			show: PropTypes.bool
		}
	}

	static get defaultProps() {
		return {
			url: "#",
			items: [],
			show: false
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			collapsed: false
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.active !== this.props.active) {
		    this.setState({show: this.props.active})
		}
	}

	get className() {
      let classList = [];

      if (this.props.url === router.currentUrl) {
        classList.push("active");

      }
      if (this.state.collapsed && screen.mobile()) {
        classList.push("collapsed");
        classList.push('active-transition')
      }

      if (this.state.show && screen.desktop()) {
        classList.push("show");
      }

      return classList.join(" ");
    }

	_toggleCollapse = e => {
		if (screen.mobile() && !e.target.classList.contains('inner-expand-toggle')) {
          this.setState({collapsed: !this.state.collapsed});

        }
	};

    _onMouseOver = () => {
		this.props.activate();
	};

	_onMouseOut = () => {
		this.props.deactivate();
	};

	renderGroups() {
		return this.props.items.map((item, i) => {
			return (
				<Group key={i} url={item.url} title={item.title}>
					{item.items.map((item, i) => {
						return (
							<li key={i} className={(item.url === router.currentUrl)?'active':''}>
								<a href={item.url}>{item.title}</a>
							</li>
						);
					})}
				</Group>
			);
		});
	}

	render() {
		return (
			<li className={this.className} 
					onClick={this._toggleCollapse} 
					onMouseEnter={this._onMouseOver} 
					onMouseLeave={this._onMouseOut}
				>
				<Link href={this.props.url} preventDefault={true} >{this.props.title}</Link>
				<Link href="#" className="expand-toggle" preventDefault={true} >
					<Image src={router.url("img/arrow_down.png")} alt={this.props.title}/>
				</Link>
				<div className="groups">
					<ul>{this.renderGroups()}</ul>
				</div>
			</li>
		);
	}

}

class ShopNavigation extends PureComponent {

	static get propTypes() {
		return {
			items: PropTypes.array
		};
	}

	static get defaultProps() {
		return {
			items: []
		};
	}

	constructor(props) {
      super(props);

      this.state = {
        active: null,
      }
    }

	isActive(i) {
		return this.state.active === i;
	}

	changeActive = debounce(300, (i) => {
		this.setState({active: i});
	});

	renderItems() {
		return this.props.items.map((item, i) => {
			return (
				<MenuItem key={i} {...item} active={this.isActive(i)} activate={() => this.changeActive(i)} deactivate={() => this.changeActive(null)}/>
			);
		});
	}

	render() {
		return (
			<ul className="shop-navigation">
				{this.renderItems()}
			</ul>
		);
	}

}

module.exports = ShopNavigation;
